import { FC } from 'react';
import { RouterProvider, createBrowserRouter, RouteObject } from 'react-router-dom';
import RootLayout from './pages/Root';
import { appRoutes } from './routes';
import { Analytics } from '@vercel/analytics/react';

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: appRoutes as RouteObject[],
  },
]);

const App: FC = () => {
  return (
    <>
      <RouterProvider router={router} />
      <Analytics />
    </>
  );
};

export default App;
